import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import Project2192 from './components/Project2192';
import Project1636 from './components/Project1636';

function App() {
    return (
        <Routes>
            {/* Home page at the root path */}
            <Route path="/" element={<HomePage />} />

            {/* Profile page */}
            <Route path="/p2192" element={<Project2192 />} />
			<Route path="/p1636" element={<Project1636 />} />
        </Routes>
    )
}

export default App;
